export const getClientFeatures = () => window.Modernizr || {};
export const hasClientFeature = feature =>
  Boolean(getClientFeatures()[feature]);

export const isIOS = Boolean(
  navigator.platform && /iPad|iPhone|iPod/i.test(navigator.platform)
);



// WEBPACK FOOTER //
// ./src/helpers/client.js